export const DEFAULT_IMAGE_CLOUDINESS = 20
export const getImageCloudinessKey = (land, product) =>
  JSON.stringify([land?.company_id || '', land?.land_id || '', product])
